import { connect } from 'react-redux';
import { getServices, restartService } from '../../redux/actions/serviceManager';
import { ServiceManagerComponent } from '../../components';

const mapStateToProps = state => ({
  services: state.serviceManager.services,
  loading: state.serviceManager.loading,
  restarting: state.serviceManager.restarting
})

const mapDispatchToProps = { getServices, restartService };

export default connect(mapStateToProps, mapDispatchToProps)(ServiceManagerComponent)



// WEBPACK FOOTER //
// ./src/containers/ServiceManager/ServiceManager.js